import React, { useEffect, useState } from 'react'

import { Typography } from '@/components/ui/typography'
import { formatRelativeTime } from '@/utils'

import { relativeTimeCheckIntervalMS } from './relative-time.constants'

export interface RelativeTimeProps {
  createdAt: number
}

export const RelativeTime = ({ createdAt }: RelativeTimeProps) => {
  const [formattedTime, setFormattedTime] = useState(() => formatRelativeTime(createdAt))

  useEffect(() => {
    const interval = setInterval(() => {
      setFormattedTime(formatRelativeTime(createdAt))
    }, relativeTimeCheckIntervalMS)

    return () => clearInterval(interval)
  }, [createdAt])

  return (
    <Typography as="span" size="text-medium" weight="medium" color="black500" breakLines={true}>
      {formattedTime}
    </Typography>
  )
}
